import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import raf from 'raf';
import ease from 'ease-component';
import { each, delay } from 'lodash';
import styles from './veil.css';
import {
  getWindowWidth, getWindowHeight,
  getHeaderHeight, getFooterHeight,
} from '../../modules/App/AppReducer';

raf.polyfill();

const properties = ['width', 'height', 'top', 'left', 'right', 'bottom'];

class Veil extends Component {
  constructor(props) {
    super(props);
    this.state = {
      start: {
        width: 0, height: 0, top: 0, bottom: 0, left: 0, right: 0,
      },
      end: {
        width: 0, height: 0, top: 0, bottom: 0, left: 0, right: 0,
      },
      final: {
        width: 0, height: 0, top: 0, bottom: 0, left: 0, right: 0,
      },
      lastHeight: null,
      lastBottom: null,
      stop: true,
    };
    this.animate = this.animate.bind(this);
  }

  componentWillMount() {
    if (this.props.fullScreenMode) {
      this.checkProps(this.props);
    }
    this.checkBodyClass(this.props.fullScreenMode);
  }

  componentWillUnmount() {
    this.checkBodyClass(this.props.fullScreenMode);
  }


  componentWillReceiveProps(nextProps) {
    // if (!this.props.fullScreenMode && nextProps.fullScreenMode) {
    // }
    if (nextProps.fullScreenMode) {
      this.checkProps(nextProps);
    } else {
      this.checked = false;
    }
    this.checkBodyClass(nextProps.fullScreenMode);
  }

  checkProps(props) {
    if (!this.checked && typeof window !== 'undefined') {
      window.dispatchEvent(new window.Event('resize'));
      window.scrollTo(window.scrollX, window.scrollY - 1);
      this.checked = true;
    }
    if (!this.props.fullScreenMode) {
      if (this.props.anchorElement) {
        const anchorBound = this.props.anchorElement.getBoundingClientRect();
        this.setState({
          lastBottom: anchorBound.bottom,
          lastHeight: anchorBound.height,
        }, () => {
          this.calculate(props);
        });
        return;
      }
    }
    this.calculate(props);
  }

  checkBodyClass(/* fullScreen */) {
    if (typeof document !== 'undefined') {
      /*
      if (fullScreen) {
        document.body.classList.add(styles.veilOpen);
      } else {
        document.body.classList.remove(styles.veilOpen);
      }
      */
      delay(() => {
        // fade animation
        const cleanVeilClassName = CSS.escape(styles.veilShow);
        const els = document.querySelectorAll(`.${cleanVeilClassName}`);
        if (els && els.length > 0) {
          document.body.classList.add(styles.veilOpen);
          document.body.classList.add('veil-open');
        } else {
          document.body.classList.remove(styles.veilOpen);
          document.body.classList.remove('veil-open');
        }
      }, 500);
    }
  }

  calculate(props) {
    const {
      anchorElement,
      siteHeaderHeight,
      siteFooterHeight,
      windowHeight,
      windowWidth,
      fullScreenMode,
    } = props;
    const { lastHeight, lastBottom } = this.state;

    const end = {
      left: 0,
      right: 0,
      top: siteHeaderHeight,
      bottom: siteFooterHeight,
      width: windowWidth,
      height: windowHeight - siteHeaderHeight - siteFooterHeight,
    };
    const start = {
      left: 0,
      right: 0,
      top: siteHeaderHeight,
      bottom: siteFooterHeight,
      width: windowWidth,
      height: windowHeight - siteHeaderHeight - siteFooterHeight,
    };

    if (anchorElement) {
      const anchorBound = anchorElement.getBoundingClientRect();
      start.height = fullScreenMode ? anchorBound.height : lastHeight;
      start.bottom = fullScreenMode ? anchorBound.bottom : lastBottom;

      start.width = anchorBound.width;
      start.top = anchorBound.top;
      start.left = anchorBound.left;
      start.right = anchorBound.right;
    }
    this.startTime = Date.now();
    /*
    this.setState({
      start: fullScreenMode ? start : end,
      end: fullScreenMode ? end : start,
      stop: false,
    });
    raf(this.animate);
    */
    this.setState({
      final: fullScreenMode ? end : start,
      stop: true,
    });
  }

  animate() {
    if (this.state.stop) return;
    raf(this.animate);
    this.draw();
  }

  draw() {
    const { start, end } = this.state;
    const { duration } = this.props;
    const now = Date.now();
    let stop = false;
    if (now - this.startTime >= duration) {
      stop = true;
    }
    let easing = null;
    easing = easing && easing in ease ? easing : 'outSine';
    let percentage = (now - this.startTime) / duration;
    percentage = percentage > 1 ? 1 : percentage;
    const easeVal = ease[easing](percentage);
    const final = {};
    each(properties, (property) => {
      const startValue = start[property];
      const endValue = end[property];
      const value = startValue + ((endValue - startValue) * easeVal);
      final[property] = value;
    });
    this.setState({ final, stop });
  }

  render() {
    const { final, stop } = this.state;
    const { children, fullScreenMode, fullScreenOffset } = this.props;
    const style = {
      ...final,
    };
    const cls = [styles.veil];
    if (fullScreenMode) {
      cls.push(styles.veilShow);
    }
    if (!fullScreenMode) {
      if (stop) {
        style.width = 'auto';
        style.height = 'auto';
        style.position = 'static';
      }
    } else if (fullScreenOffset && fullScreenOffset.y) {
      style.top += fullScreenOffset.y;
      style.height -= fullScreenOffset.y;
    }
    return (
      <div
        className={cls.join(' ')}
        style={style}
      >
        {children}
      </div>
    );
  }
}


Veil.propTypes = {
  anchorElement: PropTypes.shape({
    getBoundingClientRect: PropTypes.func,
  }),
  siteHeaderHeight: PropTypes.number, // eslint-disable-line
  siteFooterHeight: PropTypes.number, // eslint-disable-line
  windowHeight: PropTypes.number,  // eslint-disable-line
  windowWidth: PropTypes.number,  // eslint-disable-line
  duration: PropTypes.number,
  children: PropTypes.node,
  fullScreenMode: PropTypes.bool,
  fullScreenOffset: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number,
  }),
};
Veil.defaultProps = {
  anchorElement: null,
  siteHeaderHeight: 0,
  siteFooterHeight: 0,
  windowWidth: 0,
  windowHeight: 0,
  duration: 100,
  children: null,
  fullScreenMode: false,
  fullScreenOffset: {
    x: 0,
    y: 0,
  },
};

function mapStateToProps(state) {
  return {
    windowWidth: getWindowWidth(state),
    windowHeight: getWindowHeight(state),
    siteHeaderHeight: getHeaderHeight(state),
    siteFooterHeight: getFooterHeight(state),
  };
}
export default connect(mapStateToProps)(Veil);
